import { useMemo, useState } from "react";
import "./VehicleCardList.css";
import LoadingSpinner from "../LoadingSpinner";
import VehicleCard from "./VehicleCard";

const VehicleCardList = ({
  isLoading,
  vehicles,
  onVehicleClick,

  openAddVehicle,
  externalQuery,
  onQueryChange,

  //for subscription payment select
  selectedIds = new Set(),
  onToggleSelect = () => {}
}) => {
  const [localQuery, setLocalQuery] = useState("");
  const query = externalQuery !== undefined ? externalQuery : localQuery;
  const setQuery =
    typeof onQueryChange === "function" ? onQueryChange : setLocalQuery;

  const filteredVehicles = useMemo(() => {
    const q = (query || "").trim().toLowerCase();
    if (!q) return vehicles;

    return vehicles.filter((v) => {
      const vehicleCode = (v.vehicleCode || "").toLowerCase();
      //const make = (v.make || '').toLowerCase();
      //const model = (v.model || '').toLowerCase();
      //const vin = (v.vin || '').toLowerCase();
      const employeeName = (v.employee?.name || "").toLowerCase();
      const employeeCode = (v.employee?.employeeCode || "").toLowerCase();
      return (
        vehicleCode.includes(q) ||
        employeeName.includes(q) ||
        employeeCode.includes(q)
      );
    });
  }, [vehicles, query]);

  return (
    <div className="vcl-root">
      {/* Search Header - Only shows if not controlled by parent */}
      {externalQuery === undefined && (
        <header className="vcl-header">
          <div className="vcl-search-wrapper">
            <i className="bi bi-search vcl-icon" />
            <input
              type="text"
              className="vcl-input"
              placeholder="Filter fleet..."
              value={query}
              onChange={(e) => setQuery(e.target.value)}
            />
            {query && (
              <button className="vcl-clear" onClick={() => setQuery("")}>
                <i className="bi bi-x-circle-fill" />
              </button>
            )}
          </div>

          {openAddVehicle && (
            <button className="vcl-btn-add" onClick={openAddVehicle}>
              <i className="bi bi-plus-lg" />
            </button>
          )}
        </header>
      )}

      <main className="vcl-body">
        {isLoading ? (
          <div className="vcl-center">
            <LoadingSpinner />
          </div>
        ) : filteredVehicles.length === 0 ? (
          <div className="vcl-empty-state">
            <div className="vcl-empty-art">
              <i className="bi bi-truck-flatbed" />
            </div>
            <h3>No Vehicles Found</h3>
            <p>Your search returned no results.</p>
            {openAddVehicle && (
              <button className="vcl-cta-empty" onClick={openAddVehicle}>
                New Vehicle
              </button>
            )}
          </div>
        ) : (
          <div className="vcl-grid">
            {filteredVehicles.map((vehicle, idx) => (
              <div
                key={vehicle._id}
                className="vcl-card-anim"
                style={{ animationDelay: `${idx * 0.05}s` }}
              >
                <VehicleCard
                  vehicle={vehicle}
                  onClick={() => onVehicleClick(vehicle)}

                  selected={selectedIds.has(vehicle._id)}
                  onToggle={() => onToggleSelect(vehicle._id)}
                  showCheckbox={
                    vehicle.subscriptionStatus !== 'ACTIVE' &&
                    vehicle.subscriptionStatus !== 'TRIAL'
                  }
                />
              </div>
            ))}
          </div>
        )}
      </main>
    </div>
  );
};

export default VehicleCardList;
